export const inputType = {type: 'Plotly'} as any;
